<template>
  <WdsAlert warning>
    <template #description>
      <img
        src="/gfx/ir35-logo-indigo.svg"
        class="pull-right m-l-10"
        style="max-width: 40px; height: auto"
      />

      <p class="f-12">
        Depending on the changes you make to this contract, an IR35 status determination may be
        required. If you are extending the contract then it might be better to create a new hire so
        as to clearly separate the two assignments, allowing them to be judged on their own merits.
      </p>

      <p v-if="hasBills" class="f-12">
        <strong>Note: The freelancer has already billed on this contract.</strong>
        If an update to the contract results in a different determination result, a new hire is
        required for the freelancer to create additional bills.
      </p>
    </template>
  </WdsAlert>
</template>

<script>
import { WdsAlert } from '@worksome/wds-components'

export default {
  components: {
    WdsAlert,
  },
  props: {
    hasBills: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
